import { render, staticRenderFns } from "./header1.vue?vue&type=template&id=1afbcf63&scoped=true&"
import script from "./header1.vue?vue&type=script&lang=js&"
export * from "./header1.vue?vue&type=script&lang=js&"
import style0 from "./header1.vue?vue&type=style&index=0&id=1afbcf63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afbcf63",
  null
  
)

export default component.exports